module.exports = __webpack_public_path__ + "img/ee_logo.dd8e3b87.svg";